export default "__VITE_ASSET__dWJAKh0b__"